import {
    GET_APP_CFG_COUNTRY_CODE_SUCCESS,
    // GET_APP_CFG_COUNTRY_CODE_ERROR,
    GET_APP_CFG_ELOG_QUESTIONS_SUCCESS,
    // GET_APP_CFG_ELOG_QUESTIONS_ERROR,
    GET_APP_CFG_PUBLIC_KEY_SUCCESS,
    GET_ARTICLES_BANNER_LIST_SUCCESS,
    // GET_ARTICLES_BANNER_LIST_ERROR,
    GET_ARTICLES_FULL_LIST_SUCCESS,
    GET_ARTICLES_VIDEOS_FULL_LIST_SUCCESS,
    GET_ARTICLES_VIDEOS_DETAIL_SUCCESS,
    GET_BANK_OPTIONS_SUCCESS,
    GET_BANK_OPTIONS_ERROR,
    GET_REWARDS_CATEGORY_LIST_SUCCESS,
    GET_REWARDS_CATEGORY_LIST_ERROR,
    GET_REWARDS_LIST_BY_CATEGORY_SUCCESS,
    GET_REWARDS_LIST_BY_CATEGORY_ERROR,
    GET_REWARDS_DETAILS_SUCCESS,
    GET_REWARDS_DETAILS_ERROR,
    REDEEM_REWARDS_SUCCESS,
    REDEEM_REWARDS_ERROR,
    SET_REMIND_UPDATE_PASSWORD
} from '../actions';

const initialState = {
    countryCodes: [],
    eLogQuestions: null,
    publicKey: null,
    articleBannerList: [],
    articleFullList: [],
    articleVideoFullList: [],
    articleVideoDetail: [],
    bankList: {},
    showRemindUpdatePassword: false
};

export default function(state = initialState, action) {
    switch(action.type) {
        case GET_ARTICLES_VIDEOS_DETAIL_SUCCESS:
            return Object.assign({}, state, {articleVideoDetail: action.payload.data.data.items});
        case GET_ARTICLES_VIDEOS_FULL_LIST_SUCCESS:
            return Object.assign({}, state, {articleVideoFullList: action.payload.data.data.items});
        case GET_ARTICLES_FULL_LIST_SUCCESS:
            return Object.assign({}, state, {articleFullList: action.payload.data.data.articles});
        case GET_ARTICLES_BANNER_LIST_SUCCESS:
            return Object.assign({}, state, {articleBannerList: action.payload.data.data.banners});
        case GET_APP_CFG_PUBLIC_KEY_SUCCESS:
            return Object.assign({}, state, {publicKey: action.payload.data.key});
        case GET_APP_CFG_ELOG_QUESTIONS_SUCCESS:
            return Object.assign({}, state, {eLogQuestions: action.payload.data.data});
        case GET_APP_CFG_COUNTRY_CODE_SUCCESS:
            return Object.assign({}, state, {countryCodes: action.payload.data.countryCodes});
        case GET_BANK_OPTIONS_SUCCESS:
            return Object.assign({}, state, {bankList: {bl:action.payload.data.bl, bbl:action.payload.data.bbl, blV2:action.payload.data.blV2}});
        case GET_REWARDS_CATEGORY_LIST_SUCCESS:
            return Object.assign({}, state, {rewardsCategoryList: action.payload.data.data.rewards_category});
        case GET_REWARDS_LIST_BY_CATEGORY_SUCCESS:
            return Object.assign({}, state, {rewardsList: action.payload.data.data.rewards});
        case GET_REWARDS_DETAILS_SUCCESS:
            return Object.assign({}, state, {reward: action.payload.data.data});
        case REDEEM_REWARDS_SUCCESS:
            // console.log('action.payload.data.data.redeemedDetails.rewardId', action.payload.data.data.redeemedDetails.rewardId);
            var rewards = state.rewardsList;
            rewards.map(_reward => {
                if (_reward.pk == action.payload.data.data.redeemedDetails.rewardId) {
                    _reward.redeemedDetails = action.payload.data.data.redeemedDetails
                }
            })

            var reward = state.reward
            if (reward.pk === action.payload.data.data.redeemedDetails.rewardId){
                reward.redeemedDetails = action.payload.data.data.redeemedDetails
            }

            // console.log('rewardsList: rewards', rewards);
            // console.log('reward:reward', reward);

            return Object.assign({}, state, {
                rewardsList: rewards,
                reward:reward
              });
        case SET_REMIND_UPDATE_PASSWORD:            
              return Object.assign({}, state, {showRemindUpdatePassword:action.payload});
        default:
            return state;
    }
}
